import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "reactstrap";
import "./CustomerStories.css";

import Customer from "../../../Assets/image/customerStories/SEA 5 Star.png";
import Footer from "../footer/footer";
import { Helmet } from "react-helmet";
import { BASEURL } from "../../../constant/constant";

const CustomerStories = () => {

    const [stories, setStories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const hasFetched = useRef(false);

    const fetchStories = async () => {
        try {
            const res = await fetch(
                `${BASEURL}/api/customerstories/getstory`,
                {
                    method: "GET",
                    redirect: "follow",
                    headers: {
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    }
                }
            );
            const json = await res.json();
            if (json.success && Array.isArray(json.data)) {
                setStories(json.data);
            } else {
                setStories([]);
            }
        } catch (err) {
            console.error(err);
            setError("Failed to load customer stories");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (hasFetched.current) return;
        fetchStories();
        hasFetched.current = true;
    }, []);
    if (loading) return <p>Loading stories...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;
    if (!stories.length) return <p>No customer stories found.</p>;
    return (
        <>
            <Helmet>
                <title>Customer Success Stories | Solar & IoT Impact | SEA</title>
                <meta name="description" content="Read real-world case studies of how Sandip electronics  and Automation (SEA) helps farmers and industries save energy with smart solar pump controllers and IoT solutions." />
                <meta name="keywords" content="Solar pump success stories, SEA customer reviews, solar inverter case studies India, agriculture automation results, IoT monitoring feedback" />
                <meta property="og:title" content="Real Impact: SEA Customer Success Stories" />
                <meta property="og:description" content="See how our IoT-powered solar solutions are transforming lives and businesses across India." />
                <meta property="og:image" content="https://official.seaiot.in/assets/success-story-preview.png" />
                <meta property="og:url" content="https://official.seaiot.in/customerstories" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://official.seaiot.in/customerstories" />
            </Helmet>

            <section className="bg-gradient-to-r from-green-50 to-blue-50 p-8">
                <div className="mx-auto second-dev">
                    {/* ===== HERO SECTION ===== */}
                    <div className=" mb-5 hero_section_top">
                        <div className="hero_section_div1">
                            <h1 className="customer-title">
                                Our Happy Farmers 🌱
                            </h1>
                            <p className="customer-subtitle">
                                Real stories from customers who trust our solar pump solutions
                            </p>
                        </div>

                        <div className="hero_section_img">
                            <img
                                src={Customer}
                                alt="Customer Satisfaction"
                                className="cus-img"
                            />
                        </div>
                    </div>
                    {/* ===== TESTIMONIAL GRID ===== */}
                    <div className="grid grid-cols-1 md:grid-cols-2 md:grid-cols-1 xl:grid-cols-3 gap-8">
                        {stories.map((story) => (
                            <div
                                key={story._id}
                                className="bg-white rounded-2xl p-8 shadow-xl border border-green-100 hover:shadow-2xl transition-shadow"
                            >
                                <div className="storycard">
                                    <div className="storycard-img-wrap">
                                        <img
                                            // src={Single}
                                            src={`${BASEURL}${story.image}`}
                                            alt={story.name}
                                            className="storycard-img"
                                        />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">{story.name}</h3>
                                        <p className="text-sm text-gray-500">{story.location}</p>
                                    </div>
                                </div>
                                <p className="text-md font-medium text-gray-700 italic">“{story.short_paragraph}”</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default CustomerStories;
